import { inject, Injectable } from '@angular/core';
import { WorldCupRepository } from '@data/repositories/world-cup.repository';
import { environment } from '@environments/environment';
import { HttpService } from '@shared/services.http';
import { GetWorldCupScheduleResp } from '@usecase/world-cup/get-world-cup-schedule/get-world-cup-schedule.type';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class WorlCupAdapter extends WorldCupRepository {
    http = inject(HttpService);

    GetWorldCupSchedule(): Observable<GetWorldCupScheduleResp> {
        return this.http.get(`${environment.serviceApi}read/v2/wec/btl/schedule_word_cup`, {});
    }
}